import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'reducers';

/**
 * Memoized selector for the AddEditCardForm component.
 * Consolidates 11 individual useSelector calls into one, reducing re-renders
 * by only recalculating when the relevant store slices change.
 */
export const selectAddEditCardFormContext = createSelector(
  [
    (state: RootState) => state.accountsStore,
    (state: RootState) => state.accountDefaults,
    (state: RootState) => state.userStore,
    (state: RootState) => state.getCardOptions,
    (state: RootState) => state.getVehicleTypes,
    (state: RootState) => state.maintenanceStore,
  ],
  (accountsStore, accountDefaults, userStore, getCardOptions, getVehicleTypes, maintenanceStore) => ({
    allAccounts: accountsStore.allAccounts,
    allAccountsIsLoading: accountsStore.isAllAccountsLoading,
    accountDefaults: accountDefaults.result,
    assignedGrandfatherClientNumber: userStore.assignedGrandfatherClientNumber,
    loggedInUser: userStore.loggedInUser,
    assignedAccountNumber: userStore.assignedAccountNumber,
    cardOptions: getCardOptions.cardOptions.profiles,
    cardOptionsAccountNumber: getCardOptions.cardOptions.accountNumber,
    cardOptionsLoading: getCardOptions.isLoading,
    vehicleTypes: getVehicleTypes.vehicleTypes,
    plasticType: maintenanceStore.plasticType,
  })
);
